webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Titel_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60fd3d42_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Titel_vue__ = __webpack_require__(75);
function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60fd3d42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Titel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60fd3d42_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Titel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Menu__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  components: {
    Menu: __WEBPACK_IMPORTED_MODULE_0__components_Menu__["a" /* default */]
  },

  computed: {
    StyleRouter: function StyleRouter() {
      if (this.mobileCheck) {
        return 'width: 90%; margin-left: 5%; margin-right: 5%;';
      } else {
        return 'width: 70%; margin-left: 15%; margin-right: 15%;';
      }
    },

    mobileCheck: function mobileCheck() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DropdownPC__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DropdownMo__ = __webpack_require__(14);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Menu',
  components: {
    DropdownPC: __WEBPACK_IMPORTED_MODULE_0__components_DropdownPC__["a" /* default */],
    DropdownMo: __WEBPACK_IMPORTED_MODULE_1__components_DropdownMo__["a" /* default */]
  },

  props: {},

  data: function data() {
    return {
      MenuPunkte: [{
        title: 'Startseite',
        items: null,
        link: '/'
      }, {
        title: 'News',
        items: null,
        link: 'News'
      }, {
        title: 'Wir',
        items: null,
        link: 'Team'
      }, {
        title: 'Unsere Idee',
        items: [{
          title: 'Konzept',
          link: 'Konzept'
        }, {
          title: 'Vorteile',
          link: 'Vorteile'
        }, {
          title: 'Experten und Kontakte',
          link: 'Experten'
        }],
        link: 'Idee'
      }, {
        title: 'Wettbewerb',
        items: null,
        link: 'Wettbewerb'
      }, {
        title: 'Kontakt',
        items: null,
        link: 'Kontakt'
      }],
      isOpen: false
    };
  },


  methods: {},

  computed: {
    mobileCheck: function mobileCheck() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },

    OpenTitle: function OpenTitle() {
      if (this.isOpen) return 'color: #98cb00; border-bottom-color: #98cb00;';
      if (!this.isOpen) return 'color: #6e171d; border-bottom-color: #6e171d;';
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DropdownPC',
  props: {
    title: { default: null },
    items: { default: null },
    link: { type: String, default: '' }
  },

  data: function data() {
    return {
      isOpen: false
    };
  },


  methods: {},

  computed: {},

  mounted: function mounted() {}
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LogoSchema.e9c561d.png";

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownMo_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_737cbd4e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownMo_vue__ = __webpack_require__(56);
function injectStyle (ssrContext) {
  __webpack_require__(55)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-737cbd4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownMo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_737cbd4e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownMo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DropdownMo__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DropdownMo',
  props: {
    title: { default: null },
    items: { default: null },
    link: { type: String, default: '' }
  },

  data: function data() {
    return {
      isOpen: false
    };
  },


  components: {
    DropdownMo: __WEBPACK_IMPORTED_MODULE_0__components_DropdownMo__["a" /* default */]
  },

  methods: {},

  computed: {},

  mounted: function mounted() {}
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_YES.55615c5.png";

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Startseite',
  data: function data() {
    return {};
  },


  computed: {
    mobileCheck: function mobileCheck() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },

  mounted: function mounted() {
    this.$ga.page('/');
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Titel__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nachricht__ = __webpack_require__(79);
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'News',

  components: {
    Titel: __WEBPACK_IMPORTED_MODULE_2__components_Titel__["a" /* default */],
    Nachricht: __WEBPACK_IMPORTED_MODULE_3__components_Nachricht__["a" /* default */]
  },

  data: function data() {
    return {
      News: []
    };
  },


  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('News').on('value', function (snap) {
      _this.News = [];
      for (var News in snap.toJSON()) {
        if (!snap.child(News + '/anzeigen').exists() || snap.child(News + '/anzeigen').val() === true) {
          _this.News.push({
            Titel: snap.child(News + '/Titel').val(),
            Datum: snap.child(News + '/Datum').val(),
            Text: snap.child(News + '/Text').val()
          });
        }
      }
      _this.News.sort(function (News1, News2) {
        var Datum1 = new Date(News1.Datum);
        var Datum2 = new Date(News2.Datum);
        if (Datum1.getYear() < Datum2.getYear()) return 1;
        if (Datum1.getYear() > Datum2.getYear()) return -1;
        if (Datum1.getMonth() < Datum2.getMonth()) return 1;
        if (Datum1.getMonth() > Datum2.getMonth()) return -1;
        if (Datum1.getDate() < Datum2.getDate()) return 1;
        if (Datum1.getDate() > Datum2.getDate()) return -1;
        return 0;
      });
    });
  }
});

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Titel',
  props: {
    title: { type: String, default: null },
    photo: { type: String, default: 'Logo' }
  },

  data: function data() {
    return {};
  },


  computed: {
    Titel: function Titel() {
      if (this.mobileCheck) {
        return 'font-size: 1.5em; margin-top: -2em;';
      } else {
        return 'font-size: 3em; margin-top: -1em;';
      }
    },

    mobileCheck: function mobileCheck() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Nachricht',
  props: {
    title: { type: String, default: null },
    date: { type: String, default: null },
    text: { type: String, default: null }
  },

  data: function data() {
    return {};
  },


  computed: {
    Datum: function Datum() {
      var Datum = new Date(this.date);
      var Wochentage = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
      var Monate = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
      return Wochentage[Datum.getDay()] + ', ' + Datum.getDate() + '. ' + Monate[Datum.getMonth()] + ' ' + (Datum.getYear() + 1900);
    },

    TextEnter: function TextEnter() {
      var Text = this.text.toString();
      while (Text.indexOf('\n\n') !== -1) {
        Text = Text.replace('\n\n', '</p><p>');
      }
      while (Text.indexOf('\n') !== -1) {
        Text = Text.replace('\n', '<br>');
      }
      return Text;
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Titel__ = __webpack_require__(1);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Wir',

  components: {
    Titel: __WEBPACK_IMPORTED_MODULE_0__components_Titel__["a" /* default */]
  },

  data: function data() {
    return {};
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Titel__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Idee',

  components: {
    Titel: __WEBPACK_IMPORTED_MODULE_0__components_Titel__["a" /* default */]
  },

  data: function data() {
    return {};
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Titel__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_KonzeptTeil__ = __webpack_require__(91);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Konzept',

  components: {
    Titel: __WEBPACK_IMPORTED_MODULE_0__components_Titel__["a" /* default */],
    KonzeptTeil: __WEBPACK_IMPORTED_MODULE_1__components_KonzeptTeil__["a" /* default */]
  },

  data: function data() {
    return {};
  },


  computed: {
    BreiteSpalten: function BreiteSpalten() {
      if (this.mobileCheck) {
        return 'width: 100%;';
      } else {
        return 'width: 49%;';
      }
    },

    mobileCheck: function mobileCheck() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'KonzeptTeil',
  props: {
    title: { type: String, default: null }
  },

  data: function data() {
    return {
      isOpen: false
    };
  },


  computed: {
    StyleTitel: function StyleTitel() {
      if (this.isOpen) {
        return 'margin-bottom: 0;';
      } else {
        return 'margin-bottom: 0.5em;';
      }
    },

    mobileCheck: function mobileCheck() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Titel__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Vorteil__ = __webpack_require__(98);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Vorteile',

  components: {
    Titel: __WEBPACK_IMPORTED_MODULE_0__components_Titel__["a" /* default */],
    Vorteil: __WEBPACK_IMPORTED_MODULE_1__components_Vorteil__["a" /* default */]
  },

  data: function data() {
    return {};
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Vorteil',
  props: {
    title: { type: String, default: null }
  },

  data: function data() {
    return {
      isOpen: false
    };
  },


  computed: {
    StyleTitel: function StyleTitel() {
      if (this.isOpen) {
        return 'margin-bottom: 0;';
      } else {
        return 'margin-bottom: 0.5em;';
      }
    },

    mobileCheck: function mobileCheck() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Titel__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Experte__ = __webpack_require__(104);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Experten',

  components: {
    Titel: __WEBPACK_IMPORTED_MODULE_2__components_Titel__["a" /* default */],
    Experte: __WEBPACK_IMPORTED_MODULE_3__components_Experte__["a" /* default */]
  },

  data: function data() {
    return {
      Experten: [{
        Name: 'Dr. Felix Rösel',
        Amt: 'Wissenschaftlicher Mitarbeiter ifo Dresden',
        Website: 'https://www.ifo.de/forschung/ifo-dresden',
        WebsiteText: 'www.ifo.de/forschung/ifo-dresden',
        Foto: 'ifo'
      }, {
        Name: 'Prof. Dr. Joachim Ragnitz',
        Amt: 'Stellvertretender Leiter ifo Dresden',
        Website: 'https://www.ifo.de/forschung/ifo-dresden',
        WebsiteText: 'www.ifo.de/forschung/ifo-dresden',
        Foto: 'ifo'
      }, {
        Name: 'Prof. Dr. Marcel Thum',
        Amt: 'Leiter ifo Dresden',
        Website: 'https://www.ifo.de/forschung/ifo-dresden',
        WebsiteText: 'www.ifo.de/forschung/ifo-dresden',
        Foto: 'ifo'
      }]
    };
  },


  computed: {
    mobileCheck: function mobileCheck() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },

    Experten1: function Experten1() {
      var R = [];
      for (var Experte in this.Experten) {
        if (this.Experten[Experte].Position % 2 === 1) {
          R.push(this.Experten[Experte]);
        }
      }
      return R;
    },

    Experten2: function Experten2() {
      var R = [];
      for (var Experte in this.Experten) {
        if (this.Experten[Experte].Position % 2 === 0) {
          R.push(this.Experten[Experte]);
        }
      }
      return R;
    }
  },

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('Experten').on('value', function (snap) {
      _this.Experten = [];
      for (var Experte in snap.toJSON()) {
        if (!snap.child(Experte + '/anzeigen').exists() || snap.child(Experte + '/anzeigen').val() === true) {
          _this.Experten.push({
            Name: snap.child(Experte + '/Name').val(),
            Amt: snap.child(Experte + '/Amt').val(),
            Website: snap.child(Experte + '/Website').val(),
            WebsiteText: snap.child(Experte + '/WebsiteText').val(),
            Foto: snap.child(Experte + '/Foto').val(),
            Position: snap.child(Experte + '/Position').val(),
            Partei: snap.child(Experte + '/Partei').val()
          });
        }
      }
      _this.Experten.sort(function (Experte1, Experte2) {
        if (Experte1.Position < Experte2.Position) return -1;
        if (Experte1.Position > Experte2.Position) return 1;
        return 0;
      });
    });
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Experte',
  props: {
    name: { type: String, default: null },
    amt: { type: String, default: null },
    website: { type: String, default: null },
    websiteText: { type: String, default: null },
    foto: { type: String, default: null },
    parteiRechts: { txpe: String, default: null },
    parteiUnten: { txpe: String, default: null }
  },

  data: function data() {
    return {};
  },


  computed: {
    mobileCheck: function mobileCheck() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Linke.12ff663.png";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/SPD.5cb43c2.png";

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Grune.f0777ba.png";

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/FDP.d61ea66.png";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/FW.7c7dc05.png";

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/AfD.e073b7f.png";

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Titel__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Frage__ = __webpack_require__(129);
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FAQ',

  components: {
    Titel: __WEBPACK_IMPORTED_MODULE_2__components_Titel__["a" /* default */],
    Frage: __WEBPACK_IMPORTED_MODULE_3__components_Frage__["a" /* default */]
  },

  data: function data() {
    return {
      Fragen: []
    };
  },


  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('FAQ').on('value', function (snap) {
      _this.Fragen = [];
      for (var Frage in snap.toJSON()) {
        if (!snap.child(Frage + '/anzeigen').exists() || snap.child(Frage + '/anzeigen').val() === true) {
          _this.Fragen.push({
            title: snap.child(Frage + '/Frage').val(),
            text: snap.child(Frage + '/Text').val(),
            position: snap.child(Frage + '/Position').val()
          });
        }
      }
      _this.Fragen.sort(function (Frage1, Frage2) {
        if (Frage1.position < Frage2.position) return -1;
        if (Frage1.position > Frage2.position) return 1;
        return 0;
      });
    });
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Frage',
  props: {
    title: { type: String, default: null },
    text: { type: String, default: null }
  },

  data: function data() {
    return {
      isOpen: false
    };
  },


  computed: {
    StyleTitel: function StyleTitel() {
      if (this.isOpen) {
        return 'margin-bottom: 0;';
      } else {
        return 'margin-bottom: 0.5em;';
      }
    },

    mobileCheck: function mobileCheck() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },

    TextEnter: function TextEnter() {
      var Text = this.text.toString();
      while (Text.indexOf('\n\n') !== -1) {
        Text = Text.replace('\n\n', '</p><p>');
      }
      while (Text.indexOf('\n') !== -1) {
        Text = Text.replace('\n', '<br>');
      }
      return Text;
    }
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Titel__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Wettbewerb',

  components: {
    Titel: __WEBPACK_IMPORTED_MODULE_0__components_Titel__["a" /* default */]
  },

  data: function data() {
    return {};
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Titel__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Kontakt',

  components: {
    Titel: __WEBPACK_IMPORTED_MODULE_0__components_Titel__["a" /* default */]
  },

  data: function data() {
    return {};
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Titel__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Impressum',

  components: {
    Titel: __WEBPACK_IMPORTED_MODULE_0__components_Titel__["a" /* default */]
  },

  data: function data() {
    return {};
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Titel__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Datenschutz',

  components: {
    Titel: __WEBPACK_IMPORTED_MODULE_0__components_Titel__["a" /* default */]
  },

  data: function data() {
    return {};
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_analytics__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_analytics___default.a, {
  id: 'UA-170803278-1',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

var app = '';

var firebaseConfig = {
  apiKey: 'AIzaSyC3LIV0XrsUUnqK6uMpoNwHDBkKvYBsajE',
  authDomain: 'lausitz-mit-zukunft.firebaseapp.com',
  databaseURL: 'https://lausitz-mit-zukunft.firebaseio.com',
  projectId: 'lausitz-mit-zukunft',
  storageBucket: 'lausitz-mit-zukunft.appspot.com',
  messagingSenderId: '643780820483',
  appId: '1:643780820483:web:174fe7ab916f0575805836',
  measurementId: 'G-FGT7XY2843'
};

__WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.initializeApp(firebaseConfig);

__WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().onAuthStateChanged(function () {
  if (!app) {
    app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
      router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
      render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
      }
    }).$mount('#app');
  }
});

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e5497e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(58);
function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e5497e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96d2626c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__(57);
function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-96d2626c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96d2626c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownPC_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83b23f38_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownPC_vue__ = __webpack_require__(54);
function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-83b23f38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownPC_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83b23f38_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownPC_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Rahmen"},on:{"mouseover":function($event){_vm.isOpen = true},"mouseleave":function($event){_vm.isOpen = false}}},[_c('router-link',{staticStyle:{"color":"inherit"},attrs:{"to":_vm.link}},[(_vm.title === 'Startseite')?_c('img',{staticStyle:{"height":"2em","float":"left"},attrs:{"src":__webpack_require__(13),"alt":"Logo"}}):_vm._e(),_vm._v(" "),(_vm.title !== 'Startseite')?_c('div',{staticStyle:{"font-size":"2em","float":"left"}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.items)?_c('div',{staticStyle:{"font-size":"2em","float":"left","margin-left":"5px","padding-left":"3px","padding-right":"3px","background-color":"#6e171d","color":"#FFFFFF","border-radius":"1em"}},[_vm._v("+")]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","appear":""}},[(_vm.isOpen)?_c('div',{attrs:{"id":"subMenu"}},_vm._l((_vm.items),function(item){return _c('router-link',{key:item.title,attrs:{"to":item.link,"id":"subItem"}},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")])}),1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Rahmen"},on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('router-link',{attrs:{"to":_vm.link}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('DropdownMo',{key:item.title,staticStyle:{"font-size":"0.7em","border":"0"},attrs:{"title":item.title,"link":item.link}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Menu"}},[_vm._l((_vm.MenuPunkte),function(item){return (!_vm.mobileCheck)?_c('DropdownPC',{key:item.title,attrs:{"title":item.title,"items":item.items,"link":item.link}}):_vm._e()}),_vm._v(" "),(_vm.mobileCheck)?_c('div',{staticStyle:{"border-bottom":"1px solid transparent","width":"100%","font-size":"1.5em"},style:(_vm.OpenTitle),on:{"click":function($event){_vm.isOpen = !_vm.isOpen}}},[_vm._v("MENÜ"),_c('div',{staticStyle:{"float":"right","margin-right":"1em"}},[_vm._v("≡")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.MenuPunkte),function(item){return (_vm.mobileCheck && _vm.isOpen)?_c('DropdownMo',{key:item.title,attrs:{"title":item.title,"items":item.items,"link":item.link},on:{"clicked":function($event){_vm.isOpen = false}}}):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"id":"Hintergrund","src":__webpack_require__(13)}}),_vm._v(" "),_c('div',{attrs:{"id":"Inhalt"}},[_c('Menu'),_vm._v(" "),_c('router-view',{style:(_vm.StyleRouter),attrs:{"id":"MainRouter"}})],1),_vm._v(" "),_c('div',{attrs:{"id":"Footer"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"Recht"},[_c('router-link',{attrs:{"id":"Recht","to":"Impressum"}},[_vm._v("Impressum")]),_vm._v("\n      /\n      "),_c('router-link',{attrs:{"id":"Recht","to":"Datenschutz"}},[_vm._v("Datenschutzerklärung")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"Logo",attrs:{"href":"https://manos-dresden.de","target":"blank","alt":"MANOS"}},[_c('img',{attrs:{"id":"LogoQ","src":__webpack_require__(59)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"Logo",attrs:{"href":"https://ifo.de/forschung/ifo-dresden","target":"blank","alt":"ifo"}},[_c('img',{attrs:{"id":"LogoB","src":__webpack_require__(60)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"Logo",attrs:{"href":"https://young-economic-summit.org","target":"blank","alt":"YES"}},[_c('img',{attrs:{"id":"LogoB","src":__webpack_require__(16)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"Logo",attrs:{"href":"https://www.instagram.com/lausitz_mit_zukunft/","target":"blank","alt":"Instagram"}},[_c('img',{attrs:{"id":"LogoQ","src":__webpack_require__(61)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"Logo",attrs:{"href":"https://twitter.com/ZukunftLausitz","target":"blank","alt":"Twitter"}},[_c('img',{attrs:{"id":"LogoQ","src":__webpack_require__(62)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"Logo",attrs:{"href":"https://www.facebook.com/LausitzMitZukunft","target":"blank","alt":"facebook"}},[_c('img',{attrs:{"id":"LogoQ","src":__webpack_require__(63)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_Manos.df47818.png";

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_ifo.61ce19f.png";

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Instagram.3d16911.png";

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Startseite__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_News__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Wir__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Idee__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Konzept__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Vorteile__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Experten__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_FAQ__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Wettbewerb__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Kontakt__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Impressum__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Datenschutz__ = __webpack_require__(142);
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '*',
    redirect: '/'
  }, {
    path: '/',
    name: 'Startseite',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Startseite__["a" /* default */]
  }, {
    path: '/News',
    name: 'News',
    component: __WEBPACK_IMPORTED_MODULE_3__views_News__["a" /* default */]
  }, {
    path: '/Team',
    name: 'Wir',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Wir__["a" /* default */]
  }, {
    path: '/Idee',
    name: 'Idee',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Idee__["a" /* default */]
  }, {
    path: '/Konzept',
    name: 'Konzept',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Konzept__["a" /* default */]
  }, {
    path: '/Vorteile',
    name: 'Vorteile',
    component: __WEBPACK_IMPORTED_MODULE_7__views_Vorteile__["a" /* default */]
  }, {
    path: '/Experten',
    name: 'Experten',
    component: __WEBPACK_IMPORTED_MODULE_8__views_Experten__["a" /* default */]
  }, {
    path: '/FAQ',
    name: 'FAQ',
    component: __WEBPACK_IMPORTED_MODULE_9__views_FAQ__["a" /* default */]
  }, {
    path: '/Wettbewerb',
    name: 'Wettbewerb',
    component: __WEBPACK_IMPORTED_MODULE_10__views_Wettbewerb__["a" /* default */]
  }, {
    path: '/Kontakt',
    name: 'Kontakt',
    component: __WEBPACK_IMPORTED_MODULE_11__views_Kontakt__["a" /* default */]
  }, {
    path: '/Impressum',
    name: 'Impressum',
    component: __WEBPACK_IMPORTED_MODULE_12__views_Impressum__["a" /* default */]
  }, {
    path: '/Datenschutz',
    name: 'Datenschutz',
    component: __WEBPACK_IMPORTED_MODULE_13__views_Datenschutz__["a" /* default */]
  }]
}));

/***/ }),
/* 65 */,
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Startseite_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2305ae75_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Startseite_vue__ = __webpack_require__(68);
function injectStyle (ssrContext) {
  __webpack_require__(67)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2305ae75"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Startseite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2305ae75_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Startseite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"R"}},[(!_vm.mobileCheck)?_c('img',{staticStyle:{"float":"right","width":"50%","margin-left":"1em","margin-bottom":"0.5em","max-height":"100%"},attrs:{"src":__webpack_require__(69)}}):_vm._e(),_vm._v(" "),(_vm.mobileCheck)?_c('img',{staticStyle:{"float":"right","width":"45%","margin-left":"0.5em","max-height":"100%"},attrs:{"src":__webpack_require__(70),"alt":"Logo"}}):_vm._e(),_vm._v(" "),_c('p',{attrs:{"id":"Zitat"}},[_vm._v("„Es ist nicht gesagt, dass es besser wird, wenn es anders wird. Wenn es aber besser werden soll, muss es anders werden.“")]),_vm._v(" "),_c('p',{attrs:{"id":"Name"}},[_vm._v("Georg Christoph Lichtenberg (1742-1799)")]),_vm._v(" "),_vm._m(0),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"Team"}},[_vm._v("Wir sind drei Schüler aus Dresden")]),_vm._v(" und in Kooperation mit dem "),_c('b',[_vm._v("ifo-Institut Dresden")]),_vm._v(" haben wir im Rahmen des "),_c('router-link',{attrs:{"to":"Wettbewerb"}},[_vm._v("„Young Economic Summit“")]),_vm._v(" ein "),_c('router-link',{attrs:{"to":"Idee"}},[_vm._v("Konzept")]),_vm._v(" entworfen, mit dem wir die BürgerInnen der betroffenen Braunkohleregionen direkt in den Struktur­wandel in ihrer Region einbinden können.")],1),_vm._v(" "),_c('p',[_vm._v("Auf dieser Seite wollen wir über unsere Idee informieren, um so Menschen von diesem Ansatz zu überzeugen und einen Beitrag zum erfolgreichen Struktur­wandel leisten.")]),_vm._v(" "),_vm._m(4)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Der "),_c('b',[_vm._v("Kohleausstieg")]),_vm._v(" bis zum Jahr 2038 ist für das Klima und die Natur alternativlos, doch muss verhindert werden, dass dieser Wandel für die betroffenen Regionen zur Existenz­frage wird.\n  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Auch den "),_c('b',[_vm._v("ostdeutschen Braun­kohle­regionen")]),_vm._v(" steht in den nächsten Jahren und Jahrzehnten ein aufwändiger und nichts­desto­trotz überlebens­wichtiger Struktur­wandel bevor. Aber vor allem die demo­grafische Entwicklung in den ländlich geprägten Gebieten wie in der Lausitz macht bisher wenig Hoffnung, dass die Regionen diesen Wandel unbeschadet überstehen und auch in Zukunft für junge Menschen eine lebenswerte Umgebung bieten können.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Um den "),_c('b',[_vm._v("Struktur­wandel")]),_vm._v(" zu unter­stützen und die Regionen somit auch langfristig am Leben zu erhalten, werden große Mengen Geld in die Hand genommen. Allein für die Lausitz sind dabei sechs Milliarden Euro geplant. Allerdings gestaltet sich zurzeit die Verteilung dieser Gelder sehr umständlich, da die unterschiedlichsten Akteure der Bundes-, Landes- und Kommunal­politik versuchen, ihren Einfluss geltend zu machen und diese Unsummen im eigenen Interesse zu verteilen.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Doch bei all diesen hoch­politischen und zweifelsohne wichtigen Debatten um die Zukunft der Braun­kohle­regionen stehen die wichtigsten Beteiligten des strukturellen Wandels nur am Rand: die betroffenen "),_c('b',[_vm._v("Bürgerinnen und Bürger")]),_vm._v(". Und genau das wollen wir ändern.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"font-size":"1.5em"}},[_c('i',[_c('b',[_vm._v("Für eine Lausitz mit Zukunft!")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo.8388302.png";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LogoKlein.21d47d3.png";

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bf96498_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__(82);
function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bf96498"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bf96498_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.photo==='Logo')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(76),"alt":"Logo"}}):_vm._e(),_vm._v(" "),(_vm.photo==='Wir')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(77),"alt":"Logo"}}):_vm._e(),_vm._v(" "),(_vm.photo==='YES')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(78),"alt":"Logo"}}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","z-index":"1","margin-top":"-3em","width":"100%","height":"3em","background-color":"#FFFFFF","opacity":"0.8"}}),_vm._v(" "),_c('h1',{staticStyle:{"text-align":"right","position":"relative","z-index":"2","color":"#6e171d"},style:(_vm.Titel)},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LogoSchmal.e123e82.png";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Wir.ec31f3a.png";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Schild_YES.47c23c0.png";

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nachricht_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce896ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nachricht_vue__ = __webpack_require__(81);
function injectStyle (ssrContext) {
  __webpack_require__(80)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ce896ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nachricht_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce896ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nachricht_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Rahmen"}},[_c('div',{attrs:{"id":"Titel"}},[_c('span',{attrs:{"id":"TitelText"},domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('br'),_vm._v(" "),_c('span',{attrs:{"id":"Datum"}},[_vm._v(_vm._s(_vm.Datum))])]),_vm._v(" "),(_vm.text !== null)?_c('div',{attrs:{"id":"Text"}},[_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.TextEnter)}})])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titel',{attrs:{"title":"News"}}),_c('br'),_vm._v(" "),_vm._l((_vm.News),function(Nachricht){return _c('Nachricht',{key:Nachricht.Titel,attrs:{"title":Nachricht.Titel,"date":Nachricht.Datum,"text":Nachricht.Text}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wir_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4860c474_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wir_vue__ = __webpack_require__(85);
function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4860c474"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wir_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4860c474_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wir_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titel',{attrs:{"title":"Das sind wir","photo":"Wir"}}),_vm._v(" "),_c('p',[_vm._v("Wir sind "),_c('b',[_vm._v("Simon Kurtenbach, Sebastian Mitte und Tim Schwarzbach")]),_vm._v(" und besuchen zurzeit alle die Sekundar­stufe II am "),_c('b',[_vm._v("Martin-Andersen-Nexö Gymnasium")]),_vm._v(" in Dresden. Trotz der mathematisch-naturwissen­schaftlichen Vertiefung unserer Schule sind wir sehr am "),_c('b',[_vm._v("politischen und wirtschaftlichen")]),_vm._v(" Geschehen in Deutschland und der Welt interessiert, weshalb wir uns auch Anfang des letzten Schuljahres für die Teilnahme am "),_c('router-link',{attrs:{"to":"Wettbewerb"}},[_vm._v("„Young Economic Summit“")]),_vm._v(" entschieden haben.")],1),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Das Thema "),_c('b',[_vm._v("Struktur­wandel in der Lausitz")]),_vm._v(" hat uns dabei besonders interessiert, da wir als gebürtige Sachsen schon häufiger in der Region unterwegs waren und uns somit das Schicksal der Lausitz, wenn auch als Dresdner nur indirekt, betrifft. Wir hoffen, mit unserem Ansatz für eine bessere Beteiligung der betroffenen Bevölkerung dabei mitzuhelfen, dass diese wunderschöne Region auch nach dem endgültigen Kohle­ausstieg 2038 eine Zukunft hat.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Idee_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_908142a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Idee_vue__ = __webpack_require__(88);
function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-908142a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Idee_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_908142a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Idee_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titel',{attrs:{"title":"Unsere Idee - Lausitz mit Zukunft?!"}}),_vm._v(" "),_c('p',[_vm._v("Mit "),_c('router-link',{attrs:{"to":"Konzept"}},[_vm._v("unserem Konzept")]),_vm._v(" wollen wir erreichen, dass die Betroffenen im Rahmen des Struktur­wandels eine Stimme bekommen und mit Hilfe eines eigenen Budgets ihre eigenen Entscheidungen treffen können. Dabei soll es aber nicht darum gehen, den politischen Akteuren Kompetenzen streitig zu machen; vielmehr soll durch die Verteilung eines Teils des vom Bund geplanten Geldes durch die BürgerInnen ein Beitrag zum Gelingen des Wandels geleistet werden. Dies gelingt, indem die sogenannten "),_c('b',[_vm._v("weichen Standort­faktoren")]),_vm._v(", also solche, die sich direkt auf die Lebensqualität auswirken, von denen bestimmt werden, die in diesem Bereich die besten Experten sind: die BürgerInnen selbst!")],1),_vm._v(" "),_c('p',[_vm._v("Dazu haben wir einen "),_c('router-link',{attrs:{"to":"Konzept"}},[_vm._v("Plan")]),_vm._v(" entwickelt, mit dem die "),_c('b',[_vm._v("Beteiligung aller BürgerInnen")]),_vm._v(" organisiert werden kann, ohne dabei durch die Vielzahl der Interessen den Überblick zu verlieren. Mit einer Kombination aus gelosten Bürger­räten und lokalen Politikern, die mit Hilfe von Experten über die Zulassung von Projekt­vorschlägen beraten, erreichen wir ein möglichst repräsentatives und damit aussagekräftiges Ergebnis. Im Allgemeinen sollen durch die von uns vorge­schlagenen Strukturen "),_c('b',[_vm._v("Projektideen")]),_vm._v(" generiert, ausgewählt und nach einer Abstimmung durch alle BürgerInnen umgesetzt werden.")],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"Konzept"}},[_vm._v("Hier")]),_vm._v(" wird das Konzept näher vorgestellt.")],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Die Grundidee lässt sich dabei mit einer "),_c('b',[_vm._v("Sanduhr")]),_vm._v(" vergleichen. Am Anfang unseres Prozesses können alle BürgerInnen Ideen und Vorschläge einbringen, die dann in einem Kontroll­gremium beraten werden. Schluss­endlich stehen die zugelassenen Projekte wiederum zur Wahl unter allen BürgerInnen der jeweils von der Idee betroffenen Region.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Konzept_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f99ffa2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Konzept_vue__ = __webpack_require__(94);
function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f99ffa2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Konzept_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f99ffa2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Konzept_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KonzeptTeil_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_521097a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KonzeptTeil_vue__ = __webpack_require__(93);
function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-521097a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KonzeptTeil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_521097a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KonzeptTeil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Rahmen"}},[_c('div',{style:(_vm.StyleTitel),attrs:{"id":"Titel"},on:{"click":function($event){_vm.isOpen=!_vm.isOpen}}},[(!_vm.isOpen)?_c('span',{attrs:{"id":"PlusMinus"}},[_vm._v("+")]):_vm._e(),_vm._v(" "),(_vm.isOpen)?_c('span',{attrs:{"id":"PlusMinus"}},[_vm._v("-")]):_vm._e(),_vm._v(" "),_c('span',{attrs:{"if":"TitelText"}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(_vm.isOpen)?_c('div',{attrs:{"id":"Text"}},[_c('p',[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titel',{attrs:{"title":"Unser Konzept"}}),_vm._v(" "),_c('div',{staticStyle:{"float":"right","margin-top":"1em"},style:(_vm.BreiteSpalten)},[_c('br'),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","float":"right"},attrs:{"src":__webpack_require__(95)}})]),_vm._v(" "),_c('div',{staticStyle:{"float":"left","margin-top":"1em"},style:(_vm.BreiteSpalten)},[_c('KonzeptTeil',{attrs:{"title":"Lausitzforum"}},[_c('p',[_vm._v("Um die nötigen "),_c('b',[_vm._v("Projekt­ideen zu finden, zu diskutieren und zu verbessern")]),_vm._v(", bedarf es eines Zusammen­treffens interessierter und enga­gierter BürgerInnen. Denn es scheint, als mangele es nicht an den Ideen selbst, sondern an der Möglich­keit, diese zu ver­breiten. Dafür haben wir das so­ge­nannte Lausitz­forum geplant. Hier soll genau diese Möglich­keit zum Aus­tausch über Ideen für die eigene Region gegeben sein. Es handelt sich dabei um messe­ähnliche Ver­an­staltungen die "),_c('b',[_vm._v("jährlich")]),_vm._v(" in der Lausitz statt­finden sollen. So erreichen wir möglichst viele BürgerInnen und regen zum Nachdenken über die Zukunft der Region an.")])]),_vm._v(" "),_c('KonzeptTeil',{attrs:{"title":"Lokalforum"}},[_c('p',[_vm._v("Die Lausitz ist groß und die Ansprüche der Menschen in den unter­schiedlichen Regionen "),_c('b',[_vm._v("sehr verschieden")]),_vm._v(". Deshalb müssen wir neben der lausitz­weiten Projekt­gestaltung auch kleinere Einheiten im Blick behalten und so "),_c('b',[_vm._v("nahe am Lebens­umfeld")]),_vm._v(" der Menschen bleiben. Um eine Gleich­be­rech­tigung der regio­nalen Unter­einheiten zu gewähr­leisten und somit eine Konkurrenz­situation zu ver­meiden, orientieren wir uns bei der Wahl der lokalen Unter­teilungen an den "),_c('b',[_vm._v("Landtags­wahl­kreisen")]),_vm._v(". Diese bieten mit etwa 60.000 Ein­wohnern genau die Größe, um das direkte Umfeld der Betroffenen im Blick zu behalten, ohne dabei zu klein­teilig zu werden und so die Arbeits­fähigkeit unseres An­satzes zu gefährden. Auch das Lokal­forum soll einmal im Jahr im ent­spre­chen­den Landtags­wahl­kreis statt­finden und genau wie das Lausitz­forum den BürgerInnen die Möglich­keit geben, Ideen zu ent­wickeln und zu ver­breiten.")])]),_vm._v(" "),_c('KonzeptTeil',{attrs:{"title":"Lokalrat"}},[_c('p',[_vm._v("Um die Sinn­haftigkeit und Umsetz­barkeit der Projekt­ideen zu gewähr­leisten, wird ein Kontroll­gremium in­stalliert, das über die Zulassung der Projekt­ideen zur Wahl durch alle BürgerInnen des ent­sprechen­den Kreises entscheidet. Aber auch eine "),_c('b',[_vm._v("Kon­kre­ti­sierung und Über­arbei­tung")]),_vm._v(" der ein­ge­brach­ten Vor­schläge wird Aufgabe dieses Rates sein. Um eine möglichst große Vielfalt und damit eine bessere Ent­schei­dungs­grund­lage zu schaffen, setzt sich dieser Rat im Ver­hältnis "),_c('b',[_vm._v("2:1")]),_vm._v(" aus "),_c('b',[_vm._v("BürgerInnen und Lokal­politikern")]),_vm._v(" zusammen. Des weiteren wird der Landrat als "),_c('b',[_vm._v("verbindendes Element")]),_vm._v(" zwischen mehreren Landtags­wahl­kreisen eines Land­kreises einen Sitz erhalten. Um die Ent­schei­dungen des Lokal­rates zu unter­stützen, wird der Rat von "),_c('b',[_vm._v("Experten")]),_vm._v(" im ent­sprechen­den Fach­gebiet her­angezogen.")]),_vm._v(" "),_c('p',[_vm._v("Als Besonderheit werden die BürgerInnen-Vertreter des Lokal­rates aus allen in dem Kreis lebenden Einwohnern "),_c('b',[_vm._v("gelost")]),_vm._v(". Dadurch soll sicher­gestellt werden, dass sich nicht nur die Menschen beteiligen, die auch vorher bereits an den lokalen Ent­schei­dungen beteiligt waren. Dabei wird als einziges Merk­mal das Alter hinzu­gezogen. In insgesamt "),_c('b',[_vm._v("fünf Alters­klassen")]),_vm._v(" werden dabei jeweils zwei Ver­treter gelost. Durch die Verteilung der Alters­gruppen "),_c('i',[_vm._v("(14-19; 20-29; 30-49; 50-64; ab 65)")]),_vm._v(" werden "),_c('b',[_vm._v("junge Menschen")]),_vm._v(" in diesem Gremium "),_c('b',[_vm._v("über­re­prä­sen­tiert")]),_vm._v(". Das ist auch in der Form so gewollt, da auch Jugend­liche ab 14 Jahren schon eine Meinung zum Struktur­wandel in ihrer Region haben und als "),_c('b',[_vm._v("zukünftig")]),_vm._v(" Berufs­tätige in der Lausitz auch schon möglichst früh eine Stimme brauchen, um die Region nach ihren Vor­stellungen zu verändern und somit für Gleich­altrige eine "),_c('b',[_vm._v("lebens­werte Umgebung")]),_vm._v(" zu schaffen.")]),_vm._v(" "),_c('p',[_vm._v("Da die Abgesandten in diesem Gremium nicht demo­kratisch legitimiert sind, dürfen diese auch keine end­gültigen Ent­schei­dungen über die Um­setzung bestimmter Projekt­ideen treffen. Diese liegt wiederum bei allen BürgerInnen im ent­sprechen­den Landtags­wahl­kreis.")]),_vm._v(" "),_c('p')]),_vm._v(" "),_c('KonzeptTeil',{attrs:{"title":"Lausitzrat"}},[_c('p',[_vm._v("Im Allgemeinen hat dieses Gremium genau dieselben Aufgaben im lausitz­weiten Kontext wie der Lokal­rat in den Landtags­wahl­kreisen. Der Lausitz­rat be­schäf­tigt sich aller­dings aus­schließ­lich mit Projekt­ideen, die das "),_c('b',[_vm._v("gesamte Gebiet der Lausitz betreffen")]),_vm._v(". Das können zum einen teure Projekte sein, deren Strahl­kraft über einen einzigen Landtags­wahl­kreis hinaus gehen, zum anderen aber auch Projekte, die sich räum­lich nicht ein­grenzen lassen oder tat­säch­lich für die gesamte Lausitz interessant sind. Der Lokal­rat setzt sich im selben Verhältnis wie die Lokal­räte zusammen. Dazu werden aus den Lokal­räten je "),_c('b',[_vm._v("ein Politiker und zwei BürgerInnen")]),_vm._v(" entsendet.")])]),_vm._v(" "),_c('KonzeptTeil',{attrs:{"title":"Abstimmung"}},[_c('p',[_vm._v("Wenn die von den BürgerInnen ein­ge­brach­ten Ideen den Lokal- bzw. Lausitz­rat durch­laufen haben, in dem sie geprüft und über­arbeitet wurden, gehen sie in die end­gül­tige Ab­stimmung. Dabei dürfen "),_c('b',[_vm._v("alle Ein­wohner")]),_vm._v(" des jeweils von der Idee be­troffenen Gebietes ab 14 Jahren ab­stimmen. Aus der Unter­teilung in einen lausitz­weiten und einen lokal bestimmten Ent­schei­dungs­weg ergibt sich auch bei der Wahl der Projekte eine Zwei­teilung. Für alle BürgerInnen der Lausitz steht somit eine Lausitz- und eine Lokal­wahl in ihrem ent­sprechen­den Landtags­wahl­kreis bevor. Für die Auswahl der Projekte hat jeder Wahl­berechtigte jeweils "),_c('b',[_vm._v("fünf Stimmen")]),_vm._v(", die er frei ver­teilen kann. Durch die Zwei­teilung setzt jeder also zehn Kreuze für seine favor­isierten Projekte. Das macht es möglich, eine "),_c('b',[_vm._v("Ge­wich­tung")]),_vm._v(" vor­zu­nehmen, um dem persönlichen Interesse mehr Ausdruck zu ver­leihen.")]),_vm._v(" "),_c('p',[_vm._v("Letztendlich werden die Projekte nach Anzahl der erhaltenen Stimmen sor­tiert und es wird geprüft, welche dieser Projekte in dieser Reihen­folge im Rahmen des Budgets umgesetzt werden kön­nen. Das "),_c('b',[_vm._v("dy­na­mi­sche Budget")]),_vm._v(" ist dabei anfangs mit zwei Millionen Euro pro Landtags­wahl­kreis und zehn Millionen Euro für lausitz­weite Projekte kalkuliert. Für 18 Landtags­wahl­kreise ergibt sich also eine jährliche Summe von etwas unter 50 Millionen Euro.")]),_vm._v(" "),_c('p',[_vm._v("An dieser Stelle soll noch einmal betont werden, dass diese Gelder allein für die Um­setzung von Projekten zur Ver­bes­serung der "),_c('b',[_vm._v("Lebens­qualität")]),_vm._v(" und des Wohl­ergehens genutzt wer­den. Infra­struktur­projekte, Ver­bes­serung der Stand­ort­faktoren für Unter­nehmen und Ähnliches bleiben von unserem Konzept "),_c('b',[_vm._v("un­an­ge­tastet")]),_vm._v(" in der Hand der zuständigen Behörden.")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Konzept.fedf74c.png";

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vorteile_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59adb62d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vorteile_vue__ = __webpack_require__(101);
function injectStyle (ssrContext) {
  __webpack_require__(97)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59adb62d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vorteile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59adb62d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vorteile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vorteil_vue__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c87f33a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vorteil_vue__ = __webpack_require__(100);
function injectStyle (ssrContext) {
  __webpack_require__(99)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c87f33a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vorteil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c87f33a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vorteil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Rahmen"}},[_c('div',{style:(_vm.StyleTitel),attrs:{"id":"Titel"},on:{"click":function($event){_vm.isOpen=!_vm.isOpen}}},[(!_vm.isOpen)?_c('span',{attrs:{"id":"PlusMinus"}},[_vm._v("+")]):_vm._e(),_vm._v(" "),(_vm.isOpen)?_c('span',{attrs:{"id":"PlusMinus"}},[_vm._v("-")]):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.isOpen)?_c('div',{attrs:{"id":"Text"}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titel',{attrs:{"title":"Die Vorteile"}}),_vm._v(" "),_c('p',{staticStyle:{"font-size":"1.5em","margin-bottom":"0.5em"}},[_vm._v("Unsere Idee ...")]),_vm._v(" "),_c('Vorteil',{attrs:{"title":"... beteiligt alle BürgerInnen."}},[_c('p',[_vm._v("Mit unserer Idee können wir die Meinung aller ein­beziehen. Ob bei der Projekt­entwicklung oder bei der letzt­endlichen Abstimmung, im Fokus unseres Konzepts stehen die BürgerInnen der Region!")])]),_vm._v(" "),_c('Vorteil',{attrs:{"title":"... stärkt junge Leute."}},[_c('p',[_vm._v("Durch die Überrepräsentation in den Lokalräten und dem Mit­bestimmungs­recht bereits ab 14 Jahren stärken wir den Einfluss junger Menschen. Denn sie sind es, die in 20 Jahren noch in der Lausitz arbeiten und leben wollen und deswegen brauchen sie auch jetzt schon eine Stimme.")])]),_vm._v(" "),_c('Vorteil',{attrs:{"title":"... hat die besten Experten."}},[_c('p',[_vm._v("Wer sollte besser wissen wie die Lebens­bedingungen der Betroffenen verbessert werden können, als die betroffenen BürgerInnen selbst? Unserer Meinung nach: Niemand! Deshalb sollte dieser Teil des Strukturwandels auch in der Hand dieser Experten bleiben.")])]),_vm._v(" "),_c('Vorteil',{attrs:{"title":"... lässt die Betroffenen selbst entscheiden."}},[_c('p',[_vm._v("Es ist frustrierend, wenn über den eigenen Kopf entschieden wird. Doch noch unschöner wird es, wenn die Betroffenen das Problem vielleicht selbst viel besser lösen können. Deshalb entscheiden bei uns die Betroffenen selbst über ihr Lebensumfeld.")])]),_vm._v(" "),_c('Vorteil',{attrs:{"title":"... beachtet regionale Unterschiede."}},[_c('p',[_vm._v("Die Lausitz ist groß und die Bedürfnisse in den unterschiedlichen Regionen sind sehr verschieden. Mit der Aufteilung in kleinere, lokale Untereinheiten können wir gewährleisten, dass diese Unterschiede beachtet werden können und die Menschen einer Region in ihrem eigenen Umfeld etwas bewegen können.")])]),_vm._v(" "),_c('Vorteil',{attrs:{"title":"... ist bundesländer&shy;übergreifend umsetzbar."}},[_c('p',[_vm._v("Vor allem in Bezug auf die Verteilung der Gelder für den Strukturwandel ist die Lage der Lausitz in zwei verschiedenen Bundesländern problematisch. Doch mit unserem Ansatz spielt das kaum eine Rolle, vielmehr soll die Lausitz als eine Region begriffen werden.")])]),_vm._v(" "),_c('Vorteil',{attrs:{"title":"... ist auf andere Regionen übertragbar."}},[_c('p',[_vm._v("Nicht nur die Lausitz steht vor großer struktureller Veränderung. Vielmehr werden sich in den nächsten Jahrzehnten immer mehr Regionen neu erfinden müssen. Neben den wirtschaftlichen Faktoren spielt auch immer das Wohlergehen der Menschen vor Ort eine große Rolle.")]),_vm._v(" "),_c('p',[_vm._v("Mit unserem Ansatz können die BürgerInnen über einen recht einfachen Weg direkt über die Zukunft ihrer Region mitentscheiden, egal ob in der Lausitz oder zum Beispiel im Ruhrgebiet.")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Experten_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1065d1c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Experten_vue__ = __webpack_require__(126);
function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d1065d1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Experten_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1065d1c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Experten_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Experte_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79250c64_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Experte_vue__ = __webpack_require__(106);
function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79250c64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Experte_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79250c64_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Experte_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"float":"left","width":"100%","background-color":"#98cb00","margin-top":"1em"}},[_c('div',{staticStyle:{"float":"left","margin":"1%","width":"20%"}},[(_vm.foto === 'ifo')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(107)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'BMWi')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(108)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Sachsen')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(109)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Bundestag')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(110)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'LandtagSN')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(111)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'LandtagBB')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(112)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Wirtschaftsregion')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(113)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Mission')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(114)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Finsterwalde')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(115)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Görlitz')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(116)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Zittau')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(117)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Perspektiven')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(118)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Allianz')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(119)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Bildung')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(120)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Burgerrat')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(121)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Todmorden')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(122)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Tempelhof')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(123)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Schottland')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(124)}}):_vm._e(),_vm._v(" "),(_vm.foto === 'Irland')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__(125)}}):_vm._e(),_vm._v(" "),(_vm.parteiUnten === 'Linke')?_c('img',{staticStyle:{"width":"100%","float":"right"},attrs:{"src":__webpack_require__(31)}}):_vm._e(),_vm._v(" "),(_vm.parteiUnten === 'SPD')?_c('img',{staticStyle:{"width":"100%","float":"right"},attrs:{"src":__webpack_require__(32)}}):_vm._e(),_vm._v(" "),(_vm.parteiUnten === 'Grüne')?_c('img',{staticStyle:{"width":"100%","float":"right"},attrs:{"src":__webpack_require__(33)}}):_vm._e(),_vm._v(" "),(_vm.parteiUnten === 'CDU')?_c('img',{staticStyle:{"width":"100%","float":"right"},attrs:{"src":__webpack_require__(34)}}):_vm._e(),_vm._v(" "),(_vm.parteiUnten === 'FDP')?_c('img',{staticStyle:{"width":"100%","float":"right"},attrs:{"src":__webpack_require__(35)}}):_vm._e(),_vm._v(" "),(_vm.parteiUnten === 'FW')?_c('img',{staticStyle:{"width":"100%","float":"right"},attrs:{"src":__webpack_require__(36)}}):_vm._e(),_vm._v(" "),(_vm.parteiUnten === 'AfD')?_c('img',{staticStyle:{"width":"100%","float":"right"},attrs:{"src":__webpack_require__(37)}}):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"float":"left","margin":"1%","width":"77%","margin-left":"0"}},[(_vm.parteiRechts === 'Linke')?_c('img',{staticStyle:{"height":"1.5em","float":"right"},attrs:{"src":__webpack_require__(31)}}):_vm._e(),_vm._v(" "),(_vm.parteiRechts === 'SPD')?_c('img',{staticStyle:{"height":"1.5em","float":"right"},attrs:{"src":__webpack_require__(32)}}):_vm._e(),_vm._v(" "),(_vm.parteiRechts === 'Grüne')?_c('img',{staticStyle:{"height":"1.5em","float":"right"},attrs:{"src":__webpack_require__(33)}}):_vm._e(),_vm._v(" "),(_vm.parteiRechts === 'CDU')?_c('img',{staticStyle:{"height":"1.5em","float":"right"},attrs:{"src":__webpack_require__(34)}}):_vm._e(),_vm._v(" "),(_vm.parteiRechts === 'FDP')?_c('img',{staticStyle:{"height":"1.5em","float":"right"},attrs:{"src":__webpack_require__(35)}}):_vm._e(),_vm._v(" "),(_vm.parteiRechts === 'FW')?_c('img',{staticStyle:{"height":"1.5em","float":"right"},attrs:{"src":__webpack_require__(36)}}):_vm._e(),_vm._v(" "),(_vm.parteiRechts === 'AfD')?_c('img',{staticStyle:{"height":"1.5em","float":"right"},attrs:{"src":__webpack_require__(37)}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"Name",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('p',{staticClass:"Amt",staticStyle:{"text-align":"left"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.amt)}})]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0.5em","text-align":"left"}},[_c('a',{staticClass:"Website",attrs:{"href":_vm.website,"target":"blank"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.websiteText)}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ifo.33a06e3.png";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/BMWi.0e5ab91.png";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Sachsen.9f00040.png";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bundestag.6241b77.png";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LandtagSN.b2727d4.png";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LandtagBB.a68cc45.png";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Wirtschaftsregion.e7e5d16.png";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mission.3aba652.png";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Finsterwalde.378b23b.png";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Gorlitz.11e78e3.png";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Zittau.5e8b6f1.png";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Perspektiven.bdbedb9.png";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Allianz.82c44cc.png";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bildung.688f1b7.png";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Burgerrat.d18a137.png";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Todmorden.2633f85.png";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Tempelhof.fbeb32b.png";

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titel',{attrs:{"title":"Unsere Experten und Kontakte"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),(_vm.mobileCheck)?_c('div',{staticStyle:{"float":"left","width":"100%"}},_vm._l((_vm.Experten),function(Experte){return _c('Experte',{key:Experte.Name,attrs:{"name":Experte.Name,"amt":Experte.Amt,"foto":Experte.Foto,"website":Experte.Website,"websiteText":Experte.WebsiteText,"parteiUnten":Experte.Partei}})}),1):_vm._e(),_vm._v(" "),(!_vm.mobileCheck)?_c('div',{staticStyle:{"float":"left","width":"49.5%","margin-right":"0.5%"}},_vm._l((_vm.Experten1),function(Experte){return _c('Experte',{key:Experte.Name,attrs:{"name":Experte.Name,"amt":Experte.Amt,"foto":Experte.Foto,"website":Experte.Website,"websiteText":Experte.WebsiteText,"parteiRechts":Experte.Partei}})}),1):_vm._e(),_vm._v(" "),(!_vm.mobileCheck)?_c('div',{staticStyle:{"float":"left","width":"49.5%","margin-left":"0.5%"}},_vm._l((_vm.Experten2),function(Experte){return _c('Experte',{key:Experte.Name,attrs:{"name":Experte.Name,"amt":Experte.Amt,"foto":Experte.Foto,"website":Experte.Website,"websiteText":Experte.WebsiteText,"parteiRechts":Experte.Partei}})}),1):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Wir haben unsere Idee nicht nur für die Schublade entwickelt, sondern uns war es wichtig, die Meinung von "),_c('b',[_vm._v("Experten in Forschung, Politik und Gesellschaft")]),_vm._v(" zu unserer Idee zu erfahren.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Deshalb haben wir uns an zahlreiche "),_c('b',[_vm._v("Politiker der Bundes-, Landes- und Kommunalebene und Vertreter zivilgesellschaftlicher Vereinigungen")]),_vm._v(" aus der Region gewandt, um die Umsetzbarkeit unserer Idee auszuloten. Das überwiegend sehr positive Feedback stimmt uns zuversichtlich, dass wir mit diesem Ansatz tatsächlich in der "),_c('b',[_vm._v("Realität mithelfen")]),_vm._v(" können, den Strukturwandel in der Lausitz zu bewältigen.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Die Übersicht auf dieser Seite stellt einen Auszug der Personen und Institutionen dar, mit denen wir im persönlichen Kontakt standen bzw. stehen oder E-Mail-Verkehr hatten, um uns mit Ihnen über unsere Idee auszutauschen. Wir möchten uns an dieser Stelle bei jedem Einzelnen der hier Aufgeführten für die "),_c('b',[_vm._v("Unterstützung und das hilfreiche Feedback bedanken")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FAQ_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6aab94_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FAQ_vue__ = __webpack_require__(132);
function injectStyle (ssrContext) {
  __webpack_require__(128)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a6aab94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FAQ_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6aab94_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FAQ_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Frage_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42810ab1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Frage_vue__ = __webpack_require__(131);
function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42810ab1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Frage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42810ab1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Frage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Rahmen"}},[_c('div',{style:(_vm.StyleTitel),attrs:{"id":"Titel"},on:{"click":function($event){_vm.isOpen=!_vm.isOpen}}},[(!_vm.isOpen && _vm.text !== null)?_c('span',{attrs:{"id":"PlusMinus"}},[_vm._v("+")]):_vm._e(),_vm._v(" "),(_vm.isOpen && _vm.text !== null)?_c('span',{attrs:{"id":"PlusMinus"}},[_vm._v("-")]):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.isOpen && _vm.text !== null)?_c('div',{attrs:{"id":"Text"}},[_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.TextEnter)}})])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titel',{attrs:{"title":"FAQ"}}),_vm._v(" "),_vm._l((_vm.Fragen),function(Frage){return _c('Frage',{key:Frage.title,attrs:{"title":Frage.title,"text":Frage.text}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wettbewerb_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a11a1cf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wettbewerb_vue__ = __webpack_require__(135);
function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a11a1cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wettbewerb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a11a1cf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wettbewerb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titel',{attrs:{"title":"Young Econommic Summit - Der Wettbewerb","photo":"YES"}}),_vm._v(" "),_c('img',{staticStyle:{"float":"right","margin":"1em","margin-right":"0","margin-bottom":"0.5em","max-width":"50%","min-width":"30%"},attrs:{"src":__webpack_require__(16)}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_c('p'),_c('p',[_vm._v("Aus diesen zwei Überlegungen ist unsere auf dieser Website "),_c('router-link',{attrs:{"to":"Idee"}},[_vm._v("vorgestellte Idee")]),_vm._v(" entstanden.")],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Unsere Idee ist im Rahmen des Wettbewerbes "),_c('b',[_vm._v("„Young Economic Summit“")]),_vm._v(" ent­standen. Das ist der größte deutsche Schul­wettbewerb zu "),_c('b',[_vm._v("wirt­schaft­lichen und gesell­schaft­lichen Heraus­forderungen")]),_vm._v(" für Teams der Jahrgangsstufen 10 bis 12.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Mit Unterstützung von Herrn Prof. Dr. Ragnitz, Herrn Dr. Rösel und Herrn Prof. Dr. Thum vom ifo-Institut Dresden bearbeiten wir seit Anfang 2020 das Thema: "),_c('b',[_vm._v("„Woher kommt die Kohle nach der Kohle? Strukturwandel in den ostdeutschen Braunkohleregionen“")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Nach anfänglicher Recherche ist uns zweierlei aufgefallen: Erstens werden wir uns als Dresdner niemals so in die Lausitzer BürgerInnen hineinversetzen können, dass wir Lösungen für ihre Probleme finden. Und zweitens gibt es ja schon Geld, die Frage ist vielmehr, wie es so gewinnbringend eingesetzt wird, dass die Region eine "),_c('b',[_vm._v("Zukunft")]),_vm._v(" hat.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kontakt_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c37d3cc0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kontakt_vue__ = __webpack_require__(138);
function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c37d3cc0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kontakt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c37d3cc0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kontakt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titel',{attrs:{"title":"Kontakt"}}),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","font-style":"italic"}},[_vm._v("Sie haben eine Frage?")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"right","font-style":"italic"}},[_vm._v("Sie möchten uns Feedback geben?")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","font-style":"italic"}},[_vm._v("Sie wollen uns Ihre Meinung zu unserer Idee mitteilen?")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"right","font-style":"italic"}},[_vm._v("... oder Sie haben ein anderes Anliegen?")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-align":"center","font-weight":"bold"}},[_vm._v("Schreiben Sie uns eine E-Mail! Wir sind erreichbar unter "),_c('a',{attrs:{"href":"mailto:lausitz-mit-zukunft@gmx.de"}},[_vm._v("lausitz-mit-zukunft@gmx.de")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Impressum_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ea22856_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Impressum_vue__ = __webpack_require__(141);
function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ea22856"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Impressum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ea22856_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Impressum_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titel',{attrs:{"title":"Impressum"}}),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Text"}},[_c('p',{staticStyle:{"float":"right","margin":"0"}},[_vm._v("Angaben gemäß § 5 TMG")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Lausitz mit Zukunft?! - Du entscheidest!")]),_c('br'),_c('br'),_vm._v("\n    Kurtenbach, Simon"),_c('br'),_vm._v("\n    Mitte, Sebastian"),_c('br'),_vm._v("\n    Schwarzbach, Tim"),_c('br'),_c('br'),_vm._v("\n    E-Mail: "),_c('a',{attrs:{"href":"mailto:lausitz-mit-zukunft@gmx.de"}},[_vm._v("lausitz-mit-zukunft@gmx.de")])]),_vm._v(" "),_c('h2',[_vm._v("Haftungsausschluss:")]),_vm._v(" "),_c('h3',[_vm._v("Haftung für Inhalte")]),_vm._v(" "),_c('p',[_vm._v("Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.")]),_vm._v(" "),_c('h3',[_vm._v("Haftung für Links")]),_vm._v(" "),_c('p',[_vm._v("Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.")]),_vm._v(" "),_c('h3',[_vm._v("Urheberrecht")]),_vm._v(" "),_c('p',[_vm._v("Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.")]),_vm._v(" "),_c('h3',[_vm._v("Datenschutz")]),_vm._v(" "),_c('p',[_vm._v("Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.")]),_vm._v(" "),_c('p',[_vm._v("Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.")]),_vm._v(" "),_c('p',[_vm._v("Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.")]),_vm._v(" "),_c('h3',[_vm._v("Google Analytics")]),_vm._v(" "),_c('p',[_vm._v("Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. (''Google''). Google Analytics verwendet sog. ''Cookies'', Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglicht. Die durch den Cookie erzeugten Informationen über Ihre Benutzung dieser Website (einschließlich Ihrer IP-Adresse) wird an einen Server von Google in den USA übertragen und dort gespeichert. Google wird diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen. Auch wird Google diese Informationen gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben oder soweit Dritte diese Daten im Auftrag von Google verarbeiten. Google wird in keinem Fall Ihre IP-Adresse mit anderen Daten der Google in Verbindung bringen. Sie können die Installation der Cookies durch eine entsprechende Einstellung Ihrer Browser Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website voll umfänglich nutzen können. Durch die Nutzung dieser Website erklären Sie sich mit der Bearbeitung der über Sie erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor benannten Zweck einverstanden.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datenschutz_vue__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30a7022e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datenschutz_vue__ = __webpack_require__(144);
function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30a7022e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datenschutz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30a7022e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datenschutz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Titel',{attrs:{"title":"Datenschutzerklärung"}}),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Text"}},[_c('h2',[_vm._v("1. Datenschutz auf einen Blick")]),_vm._v(" "),_c('h3',[_vm._v("Allgemeine Hinweise")]),_vm._v(" "),_c('p',[_vm._v("Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.")]),_vm._v(" "),_c('h3',[_vm._v("Datenerfassung auf dieser Website")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Wer ist verantwortlich für die Datenerfassung auf dieser Website?")])]),_vm._v(" "),_c('p',[_vm._v("Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Wie erfassen wir Ihre Daten?")])]),_vm._v(" "),_c('p',[_vm._v("Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.")]),_vm._v(" "),_c('p',[_vm._v("Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Wofür nutzen wir Ihre Daten?")])]),_vm._v(" "),_c('p',[_vm._v("Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Welche Rechte haben Sie bezüglich Ihrer Daten?")])]),_vm._v(" "),_c('p',[_vm._v("Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.")]),_vm._v(" "),_c('p',[_vm._v("Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.")]),_vm._v(" "),_c('h3',[_vm._v("Analyse-Tools und Tools von Drittanbietern")]),_vm._v(" "),_c('p',[_vm._v("Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit sogenannten Analyseprogrammen.")]),_vm._v(" "),_c('p',[_vm._v("Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden Datenschutzerklärung.")]),_vm._v(" "),_c('h2',[_vm._v("2. Hosting und Content Delivery Networks (CDN)")]),_vm._v(" "),_c('h3',[_vm._v("Externes Hosting")]),_vm._v(" "),_c('p',[_vm._v("Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.")]),_vm._v(" "),_c('p',[_vm._v("Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).")]),_vm._v(" "),_c('p',[_vm._v("Unser Hoster wird Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung seiner Leistungspflichten erforderlich ist und unsere Weisungen in Bezug auf diese Daten befolgen.")]),_vm._v(" "),_c('h2',[_vm._v("3. Allgemeine Hinweise und Pflichtinformationen")]),_vm._v(" "),_c('h3',[_vm._v("Datenschutz")]),_vm._v(" "),_c('p',[_vm._v("Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.")]),_vm._v(" "),_c('p',[_vm._v("Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.")]),_vm._v(" "),_c('p',[_vm._v("Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.")]),_vm._v(" "),_c('h3',[_vm._v("Hinweis zur verantwortlichen Stelle")]),_vm._v(" "),_c('p',[_vm._v("Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Lausitz mit Zukunft?! - Du entscheidest!")]),_c('br'),_vm._v("\n    Kurtenbach, Simon"),_c('br'),_vm._v("\n    Mitte, Sebastian"),_c('br'),_vm._v("\n    Schwarzbach Tim"),_c('br'),_vm._v("\n    E-Mail: "),_c('a',{attrs:{"href":"mailto:lausitz-mit-zukunft@gmx.de"}},[_vm._v("lausitz-mit-zukunft@gmx.de")])]),_vm._v(" "),_c('p',[_vm._v("Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.")]),_vm._v(" "),_c('h3',[_vm._v("Widerruf Ihrer Einwilligung zur Datenverarbeitung")]),_vm._v(" "),_c('p',[_vm._v("Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.")]),_vm._v(" "),_c('h3',[_vm._v("Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)")]),_vm._v(" "),_c('p',[_vm._v("WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).")]),_vm._v(" "),_c('p',[_vm._v("WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).")]),_vm._v(" "),_c('h3',[_vm._v("Beschwerderecht bei der zuständigen Aufsichtsbehörde")]),_vm._v(" "),_c('p',[_vm._v("Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.")]),_vm._v(" "),_c('h3',[_vm._v("Recht auf Datenübertragbarkeit")]),_vm._v(" "),_c('p',[_vm._v("Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.")]),_vm._v(" "),_c('h3',[_vm._v("Auskunft, Löschung und Berichtigung")]),_vm._v(" "),_c('p',[_vm._v("Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.")]),_vm._v(" "),_c('h3',[_vm._v("Recht auf Einschränkung der Verarbeitung")]),_vm._v(" "),_c('p',[_vm._v("Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Hierzu können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in folgenden Fällen:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.")]),_vm._v(" "),_c('li',[_vm._v("Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie statt der Löschung die Einschränkung der Datenverarbeitung verlangen.")]),_vm._v(" "),_c('li',[_vm._v("Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung, Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.")]),_vm._v(" "),_c('li',[_vm._v("Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.")])]),_vm._v(" "),_c('p',[_vm._v("Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der Europäischen Union oder eines Mitgliedstaats verarbeitet werden.")]),_vm._v(" "),_c('h2',[_vm._v("4. Datenerfassung auf dieser Website")]),_vm._v(" "),_c('h3',[_vm._v("Cookies")]),_vm._v(" "),_c('p',[_vm._v("Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.")]),_vm._v(" "),_c('p',[_vm._v("Teilweise können auch Cookies von Drittunternehmen auf Ihrem Endgerät gespeichert werden, wenn Sie unsere Seite betreten (Third-Party-Cookies). Diese ermöglichen uns oder Ihnen die Nutzung bestimmter Dienstleistungen des Drittunternehmens (z.B. Cookies zur Abwicklung von Zahlungsdienstleistungen).")]),_vm._v(" "),_c('p',[_vm._v("Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte Websitefunktionen ohne diese nicht funktionieren würden (z.B. die Warenkorbfunktion oder die Anzeige von Videos). Andere Cookies dienen dazu, das Nutzerverhalten auszuwerten oder Werbung anzuzeigen.")]),_vm._v(" "),_c('p',[_vm._v("Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs (notwendige Cookies) oder zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (funktionale Cookies, z. B. für die Warenkorbfunktion) oder zur Optimierung der Website (z.B. Cookies zur Messung des Webpublikums) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere Rechtsgrundlage angegeben wird. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung zur Speicherung von Cookies abgefragt wurde, erfolgt die Speicherung der betreffenden Cookies ausschließlich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. a DSGVO); die Einwilligung ist jederzeit widerrufbar.")]),_vm._v(" "),_c('p',[_vm._v("Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.")]),_vm._v(" "),_c('p',[_vm._v("Soweit Cookies von Drittunternehmen oder zu Analysezwecken eingesetzt werden, werden wir Sie hierüber im Rahmen dieser Datenschutzerklärung gesondert informieren und ggf. eine Einwilligung abfragen.")]),_vm._v(" "),_c('h3',[_vm._v("Anfrage per E-Mail, Telefon oder Telefax")]),_vm._v(" "),_c('p',[_vm._v("Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.")]),_vm._v(" "),_c('p',[_vm._v("Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.")]),_vm._v(" "),_c('p',[_vm._v("Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere gesetzliche Aufbewahrungsfristen – bleiben unberührt.")]),_vm._v(" "),_c('h2',[_vm._v("5. Soziale Medien")]),_vm._v(" "),_c('h3',[_vm._v("Facebook Plugins (Like & Share-Button)")]),_vm._v(" "),_c('p',[_vm._v("Auf dieser Website sind Plugins des sozialen Netzwerks Facebook integriert. Anbieter dieses Dienstes ist die Facebook Ireland Limited, 4 Grand Canal Square, Dublin 2, Irland. Die erfassten Daten werden nach Aussage von Facebook jedoch auch in die USA und in andere Drittländer übertragen.")]),_vm._v(" "),_c('p',[_vm._v("Die Facebook Plugins erkennen Sie an dem Facebook-Logo oder dem „Like-Button“ („Gefällt mir“) auf dieser Website. Eine Übersicht über die Facebook Plugins finden Sie hier: "),_c('a',{attrs:{"href":"https://developers.facebook.com/docs/plugins/?locale=de_DE","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("https://developers.facebook.com/docs/plugins/?locale=de_DE")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Wenn Sie diese Website besuchen, wird über das Plugin eine direkte Verbindung zwischen Ihrem Browser und dem Facebook-Server hergestellt. Facebook erhält dadurch die Information, dass Sie mit Ihrer IP-Adresse diese Website besucht haben. Wenn Sie den Facebook „Like-Button“ anklicken während Sie in Ihrem Facebook-Account eingeloggt sind, können Sie die Inhalte dieser Website auf Ihrem Facebook-Profil verlinken. Dadurch kann Facebook den Besuch dieser Website Ihrem Benutzerkonto zuordnen. Wir weisen darauf hin, dass wir als Anbieter der Seiten keine Kenntnis vom Inhalt der übermittelten Daten sowie deren Nutzung durch Facebook erhalten. Weitere Informationen hierzu finden Sie in der Datenschutzerklärung von Facebook unter: "),_c('a',{attrs:{"href":"https://de-de.facebook.com/privacy/explanation","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("https://de-de.facebook.com/privacy/explanation")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Wenn Sie nicht wünschen, dass Facebook den Besuch dieser Website Ihrem Facebook-Nutzerkonto zuordnen kann, loggen Sie sich bitte aus Ihrem Facebook-Benutzerkonto aus.")]),_vm._v(" "),_c('p',[_vm._v("Die Verwendung der Facebook Plugins erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an einer möglichst umfangreichen Sichtbarkeit in den Sozialen Medien. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung ist jederzeit widerrufbar.")]),_vm._v(" "),_c('h3',[_vm._v("Twitter Plugin")]),_vm._v(" "),_c('p',[_vm._v("Auf dieser Website sind Funktionen des Dienstes Twitter eingebunden. Diese Funktionen werden angeboten durch die Twitter Inc., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA. Durch das Benutzen von Twitter und der Funktion „Re-Tweet“ werden die von Ihnen besuchten Websites mit Ihrem Twitter-Account verknüpft und anderen Nutzern bekannt gegeben. Dabei werden auch Daten an Twitter übertragen. Wir weisen darauf hin, dass wir als Anbieter der Seiten keine Kenntnis vom Inhalt der übermittelten Daten sowie deren Nutzung durch Twitter erhalten. Weitere Informationen hierzu finden Sie in der Datenschutzerklärung von Twitter unter: "),_c('a',{attrs:{"href":"https://twitter.com/de/privacy","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("https://twitter.com/de/privacy")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Die Verwendung des Twitter-Plugins erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an einer möglichst umfangreichen Sichtbarkeit in den Sozialen Medien. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung ist jederzeit widerrufbar.")]),_vm._v(" "),_c('p',[_vm._v("Ihre Datenschutzeinstellungen bei Twitter können Sie in den Konto-Einstellungen unter "),_c('a',{attrs:{"href":"https://twitter.com/account/settings","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("https://twitter.com/account/settings")]),_vm._v(" ändern.")]),_vm._v(" "),_c('h3',[_vm._v("Instagram Plugin")]),_vm._v(" "),_c('p',[_vm._v("Auf dieser Website sind Funktionen des Dienstes Instagram eingebunden. Diese Funktionen werden angeboten durch die Instagram Inc., 1601 Willow Road, Menlo Park, CA 94025, USA integriert.")]),_vm._v(" "),_c('p',[_vm._v("Wenn Sie in Ihrem Instagram-Account eingeloggt sind, können Sie durch Anklicken des Instagram-Buttons die Inhalte dieser Website mit Ihrem Instagram-Profil verlinken. Dadurch kann Instagram den Besuch dieser Website Ihrem Benutzerkonto zuordnen. Wir weisen darauf hin, dass wir als Anbieter der Seiten keine Kenntnis vom Inhalt der übermittelten Daten sowie deren Nutzung durch Instagram erhalten.")]),_vm._v(" "),_c('p',[_vm._v("Die Speicherung und Analyse der Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an einer möglichst umfangreichen Sichtbarkeit in den Sozialen Medien. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung ist jederzeit widerrufbar.")]),_vm._v(" "),_c('p',[_vm._v("Weitere Informationen hierzu finden Sie in der Datenschutzerklärung von Instagram: "),_c('a',{attrs:{"href":"https://instagram.com/about/legal/privacy/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("https://instagram.com/about/legal/privacy/")]),_vm._v(".")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[44]);


// WEBPACK FOOTER //
// static/js/app.10bc788609c15baedd5d.js